import { render, staticRenderFns } from "./peoplesay.vue?vue&type=template&id=15f3b9a6&"
import script from "./peoplesay.vue?vue&type=script&lang=js&"
export * from "./peoplesay.vue?vue&type=script&lang=js&"
import style0 from "./peoplesay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports